interface LogoProps {
    className?: string,
    primaryColor?: string,
    secondaryColor?: string,
    backgroundColor?: string
}

export default function TopFXSmallLogo({
                                           className,
                                           primaryColor = 'black',
                                           secondaryColor = '#444',
                                           backgroundColor = '#C8242B'
                                       }: LogoProps): JSX.Element {


    return (<svg viewBox="0 0 627 528" fill="none" xmlns="http://www.w3.org/2000/svg" className={`${className ?? ''}`}>
            <path d="M626.24 0H363.32V263.66H626.24V0Z" fill={backgroundColor}/>
            <path d="M4 23.17V52.51H39.97V240.79H71.05V52.51H107.01V23.17H4Z" fill={primaryColor}/>
            <path
                d="M116.9 75.27C116.9 40.32 142.55 22.86 166.73 22.86C190.91 22.86 216.59 40.32 216.59 75.27V188.51C216.59 223.45 190.94 240.92 166.73 240.92C142.52 240.92 116.9 223.46 116.9 188.51V75.27ZM146.64 188.52C146.64 203.27 155.97 210.2 166.73 210.2C177.49 210.2 186.87 203.27 186.87 188.52V75.28C186.87 60.51 177.54 53.59 166.73 53.59C155.92 53.59 146.64 60.52 146.64 75.28V188.52Z"
                fill={primaryColor}/>
            <path
                d="M239.53 23.09H286.15C303.22 23.09 315.71 27.06 326.4 38.37C337.05 49.67 340.4 63.42 340.4 89.4C340.4 108.35 338.88 121.19 331.57 133.11C323.05 147.17 309.33 155.73 286.47 155.73H270.62V240.7H239.54V23.09H239.53ZM270.61 126.38H285.54C310.85 126.38 311.14 111.41 311.14 89.7C311.14 69.24 311.14 52.42 286.77 52.42H270.6V126.38H270.61Z"
                fill={primaryColor}/>
            <path
                d="M603.79 22.97H569.36L541.92 89.9L514.46 22.97H386.24V240.7H417.63V145.39H460.98V118.36H417.63V50.38H491.31L524.71 131.88L480.07 240.79H514.46L541.92 173.86L569.36 240.79H603.79L559.13 131.88L603.79 22.97Z"
                fill="white"/>
            <path
                d="M158 299H199.81C212.36 299 222.32 300.89 229.71 304.68C237.09 308.47 242.72 313.22 246.6 318.93C250.48 324.65 252.97 330.97 254.08 337.9C255.18 344.82 255.74 351.33 255.74 357.41V361.29C255.74 369.98 254.82 377.82 252.97 384.82C251.12 391.84 248.13 397.8 243.98 402.69C239.82 407.58 234.28 411.36 227.36 414.03C220.44 416.71 211.9 418.04 201.75 418.04H189.84V492.8H158V299ZM189.84 388.97H202.57C207.19 388.97 210.88 388.28 213.64 386.9C216.41 385.51 218.59 383.62 220.15 381.22C221.72 378.82 222.73 375.96 223.19 372.64C223.65 369.32 223.89 365.72 223.89 361.85V354.09C223.89 349.66 223.56 345.83 222.92 342.61C222.27 339.38 221.03 336.65 219.18 334.44C217.33 332.22 214.8 330.61 211.56 329.58C208.33 328.58 204.12 328.06 198.97 328.06H189.83V388.97H189.84Z"
                fill={secondaryColor}/>
            <path
                d="M338.24 492.8L330.49 452.38H295.6L287.3 492.8H256.57L295.05 299H331.04L369.24 492.8H338.24ZM312.48 352.71L299.19 423.58H325.78L312.49 352.71H312.48Z"
                fill={secondaryColor}/>
            <path
                d="M430.99 412.23V492.8H399.14V411.41L358.17 299H393.06L414.66 372.64H416.87L437.91 299H471.68L430.99 412.23Z"
                fill={secondaryColor}/>
            <path d="M622.564 266.143V525.857H3.45248V266.143H622.564ZM626 264H0V528H626V264Z" fill={backgroundColor}/>
        </svg>
    );
}
